export default __webpack_public_path__ + "static/media/menuAbrir.3d1dd9ff.svg";